import React, { useEffect, useState, createContext, useContext, memo } from 'react';
export type Language = 'es' | 'en';
type Translations = {
  [key: string]: string | Translations;
};
const translations: Record<Language, Translations> = {
  es: {
    nav: {
      home: 'Inicio',
      experiences: 'Experiencias',
      gallery: 'Galería',
      reviews: 'Opiniones',
      contact: 'Contacto',
      book: 'Reservar',
      bookNow: 'Reservar ahora'
    },
    hero: {
      exclusivity: 'Exclusividad garantizada',
      title1: 'Momentos que se convierten',
      title2: 'en recuerdos',
      desc: 'Experiencias picnic exclusivas en Tenerife para parejas, celebraciones y momentos inolvidables.',
      book: 'Reservar experiencia',
      see: 'Ver experiencias'
    },
    about: {
      tag: 'Sobre Nosotras',
      title1: 'Picnics diseñados para',
      title2: 'emociones',
      title3: 'reales',
      desc: 'Creamos experiencias íntimas y elegantes en los rincones más bonitos de Tenerife Sur. Cada detalle está pensado para sorprender, conectar y disfrutar momentos únicos frente al mar, la montaña o el atardecer.',
      quote: '"Los recuerdos más bonitos se diseñan con detalle."',
      btn: 'Descubrir más',
      from: 'desde Tenerife',
      withLove: 'con cariño'
    },
    experiences: {
      tag: 'Nuestras experiencias',
      title1: 'Tres maneras diseñadas',
      title2: 'para emocionar',
      desc: 'Elige tu momento y nosotras nos encargamos del resto.',
      book: 'Quiero vivirlo',
      footer: 'Cada experiencia se personaliza al 100% según tu historia.',
      tags: {
        romantic: 'ROMÁNTICO',
        proposal: 'PROPUESTA',
        anniversary: 'ANIVERSARIO',
        premium: '⭐ PREMIUM',
        birthday: 'CUMPLEAÑOS'
      },
      items: {
        sunset: {
          tag: '01 · Atardecer',
          title: 'ATARDECER',
          price: 'A partir de 170€',
          note: 'PARA 2 · TODO INCLUIDO',
          b1: 'Tabla de quesos canarios, uvas y pera',
          b2: 'Embutidos ibéricos seleccionados',
          b3: 'Pan artesanal con mermeladas',
          b4: 'Fresas con chocolate',
          b5: 'Cava o vino rosado incluido',
          b6: 'Flores · velas · mantel'
        },
        ocean: {
          tag: '02 · Océano',
          title: 'OCÉANO',
          price: 'A partir de 220€',
          note: 'PARA 2 · TODO INCLUIDO',
          b1: 'Tabla mixta de queso y ensacados canarios',
          b2: 'Wraps & sándwiches artesanales',
          b3: 'Hummus, crudités & snacks',
          b4: 'Assorti de dulces',
          b5: 'Cava, vino o zumos',
          b6: 'Decoración completa'
        },
        party: {
          tag: '03 · Fiesta',
          title: 'FIESTA',
          price: 'A partir de 300€',
          note: 'PARA 4 · TODO INCLUIDO',
          b1: 'Tabla embutidos · quesos & ibéricos',
          b2: 'Mini bocadillos · surtido variado',
          b3: 'Fruta fresca de temporada',
          b4: 'Bebidas · zumos & refrescos',
          b5: 'Decoración completa · globos, guirnaldas y mantel festivo',
          b6: 'Tarta personalizada disponible · pregunta al reservar'
        }
      }
    },
    gallery: {
      tag: 'Galería',
      title1: 'Momentos que',
      title2: 'ya hemos creado',
      desc: 'Un vistazo a los rincones, mesas y atardeceres que hemos diseñado en Tenerife.'
    },
    howWeWork: {
      tag: 'Cómo trabajamos',
      title1: 'Cuatro pasos hacia',
      title2: 'tu experiencia',
      s1t: 'Elige tu experiencia',
      s1d: 'Brunch, atardecer o celebración íntima. Tú eliges el plan que mejor resuena contigo.',
      s2t: 'Reserva tu fecha',
      s2d: 'Confirmamos disponibilidad y aseguramos tu día con una pequeña señal.',
      s3t: 'Personalizamos cada detalle',
      s3d: 'Flores, decoración, ubicación y sorpresas a medida para que todo sea único.',
      s4t: 'Disfruta el momento',
      s4d: 'Llegáis y todo está listo. Solo queda relajarse y vivir el instante.'
    },
    testimonials: {
      tag: 'Lo que dicen quienes ya lo vivieron',
      title1: 'Historias que',
      title2: 'se sienten',
      t1e: 'Cumpleaños sorpresa',
      t1q: 'Reservamos esta experiencia picnic como sorpresa por mi cumpleaños y fue absolutamente maravillosa, en una ubicación espectacular. La atención al detalle fue increíble. La recomendaría sin dudarlo.',
      t2e: 'Cena romántica',
      t2q: 'Nuestra experiencia con este equipo fue simplemente maravillosa. Organizan picnics y cenas románticas con una atención al detalle excepcional: desde la decoración elegante hasta la calidad de la comida, todo está pensado para crear una atmósfera mágica. El montaje superó nuestras expectativas y convirtió el momento en algo inolvidable.',
      t3e: 'Experiencia romántica',
      t3q: '¡Una experiencia increíble! Muy recomendable, servicio impecable y cercano, la comida preparada con un cuidado exquisito en cada detalle, la ubicación ideal y todo absolutamente delicioso. ¡Mil gracias!',
      t4e: 'Picnic en pareja',
      t4q: 'Simplemente espectacular: gente maravillosa, gran comida, excelente servicio y una comunicación impecable. Y lo más importante, una experiencia verdaderamente inolvidable.',
      t5e: 'Picnic gourmet',
      t5q: 'Experiencia impecable. Nos encantó la atención al detalle, el servicio fue excelente y la comida un 10/10. ¡Muchas gracias!'
    },
    middle: {
      tag: 'Ellos ya han vivido la experiencia',
      title1: 'Ahora faltas',
      title2: 'tú',
      btn: 'Reserva tu momento'
    },
    faq: {
      tag: 'Preguntas frecuentes',
      title1: 'Todo lo que',
      title2: 'debes saber',
      desc: 'Si tienes cualquier otra duda, estaremos encantadas de atenderte personalmente.',
      q1: '¿Cómo reservo mi experiencia?',
      a1: 'Escríbenos a través del formulario de contacto, Instagram o WhatsApp. Diseñamos tu experiencia a medida y confirmamos disponibilidad en menos de 24 horas.',
      q2: '¿Qué métodos de pago aceptáis?',
      a2: 'Aceptamos transferencia bancaria, Bizum y pago con tarjeta. Para confirmar la reserva pedimos una señal del 30% y el resto el día de la experiencia.',
      q3: '¿Cuánto dura un picnic?',
      a3: 'Las experiencias estándar duran 2 horas. Si necesitas más tiempo, podemos ampliarlo. Te dejamos disfrutar sin prisas y nosotras nos encargamos del montaje y la recogida.',
      q4: '¿Dónde se realizan los picnics?',
      a4: 'Trabajamos en tres ubicaciones seleccionadas por su belleza única: Palm Mar, con calas íntimas y vistas al Atlántico; Abama, entre vegetación tropical frente al océano; y Los Gigantes, con sus imponentes acantilados al atardecer. Si lo prefieres, te proponemos el rincón ideal según tu experiencia.',
      q5: '¿Puedo cambiar la fecha?',
      a5: 'Sí. Puedes cambiar la fecha hasta 48h antes sin coste. En caso de mal tiempo, reprogramamos sin ningún problema para que vivas la experiencia con sol.',
      q6: '¿Se puede personalizar la experiencia?',
      a6: 'Por supuesto. Decoración temática, flores específicas, mensajes, pedidas de mano, fotógrafo, músico en directo… Si lo imaginas, lo creamos.'
    },
    finalCta: {
      tag: 'Tu momento te espera',
      title1: '¿Te animas a vivir',
      title2: 'la experiencia?',
      desc: 'Creamos momentos memorables en lugares mágicos de Tenerife.',
      btn: 'Reservar ahora'
    },
    contact: {
      tag: 'Reserva tu experiencia',
      title1: 'Empecemos a',
      title2: 'diseñar tu momento',
      desc: 'Rellena el formulario y te llevamos directamente a WhatsApp con tu mensaje listo. Te respondemos en menos de 24h.',
      b1: 'Respuesta en menos de 24 horas',
      b2: 'Propuesta totalmente personalizada',
      b3: 'Sin compromiso',
      btnDirect: 'Escríbenos directamente',
      name: 'Nombre',
      namePh: '¿Cómo te llamas?',
      phone: 'Teléfono',
      phonePh: 'Tu teléfono',
      email: 'Correo',
      emailPh: 'Correo electrónico',
      exp: 'Experiencia',
      msg: 'Cuéntanos tu idea',
      msgPh: 'Cuéntanos qué experiencia deseas crear',
      btn: 'Enviar por WhatsApp',
      opt1: 'Atardecer',
      opt2: 'Océano',
      opt3: 'Fiesta'
    },
    footer: {
      nav: 'Navegación',
      contact: 'Contacto',
      wa: 'WhatsApp directo',
      desc: 'Diseñamos experiencias románticas únicas en los rincones más mágicos de Tenerife. Cada detalle cuenta una historia.',
      copy: '© 2026 Yes Picnic Tenerife · Todos los derechos reservados'
    },
    floating: {
      btn: 'Reserva por WhatsApp'
    }
  },
  en: {
    nav: {
      home: 'Home',
      experiences: 'Experiences',
      gallery: 'Gallery',
      reviews: 'Reviews',
      contact: 'Contact',
      book: 'Book',
      bookNow: 'Book now'
    },
    hero: {
      exclusivity: 'Exclusivity guaranteed',
      title1: 'Moments that become',
      title2: 'memories',
      desc: 'Exclusive picnic experiences in Tenerife for couples, celebrations, and unforgettable moments.',
      book: 'Book experience',
      see: 'See experiences'
    },
    about: {
      tag: 'About Us',
      title1: 'Picnics designed for',
      title2: 'real',
      title3: 'emotions',
      desc: 'We create intimate and elegant experiences in the most beautiful corners of Tenerife South. Every detail is designed to surprise, connect, and enjoy unique moments by the sea, the mountains, or the sunset.',
      quote: '"The most beautiful memories are designed with detail."',
      btn: 'Discover more',
      from: 'from Tenerife',
      withLove: 'with love'
    },
    experiences: {
      tag: 'Our experiences',
      title1: 'Three ways designed',
      title2: 'to thrill',
      desc: 'Choose your moment and we take care of the rest.',
      book: 'I want to live it',
      footer: 'Every experience is 100% customized to your story.',
      tags: {
        romantic: 'ROMANTIC',
        proposal: 'PROPOSAL',
        anniversary: 'ANNIVERSARY',
        premium: '⭐ PREMIUM',
        birthday: 'BIRTHDAY'
      },
      items: {
        sunset: {
          tag: '01 · Sunset',
          title: 'SUNSET',
          price: 'From 170€',
          note: 'FOR 2 · ALL INCLUSIVE',
          b1: 'Canarian cheese board, grapes and pear',
          b2: 'Selected Iberian cold cuts',
          b3: 'Artisanal bread with jams',
          b4: 'Strawberries with chocolate',
          b5: 'Cava or rosé wine included',
          b6: 'Flowers · candles · tablecloth'
        },
        ocean: {
          tag: '02 · Ocean',
          title: 'OCEAN',
          price: 'From 220€',
          note: 'FOR 2 · ALL INCLUSIVE',
          b1: 'Mixed board of Canarian cheese and cold cuts',
          b2: 'Artisanal wraps & sandwiches',
          b3: 'Hummus, crudités & snacks',
          b4: 'Assortment of sweets',
          b5: 'Cava, wine or juices',
          b6: 'Full decoration'
        },
        party: {
          tag: '03 · Celebration',
          title: 'CELEBRATION',
          price: 'From 300€',
          note: 'FOR 4 · ALL INCLUSIVE',
          b1: 'Cold cuts · cheeses & Iberian board',
          b2: 'Mini sandwiches · varied assortment',
          b3: 'Fresh seasonal fruit',
          b4: 'Drinks · juices & sodas',
          b5: 'Full decoration · balloons, garlands and festive tablecloth',
          b6: 'Custom cake available · ask when booking'
        }
      }
    },
    gallery: {
      tag: 'Gallery',
      title1: 'Moments we',
      title2: 'have already created',
      desc: 'A glimpse of the corners, tables, and sunsets we have designed across Tenerife.'
    },
    howWeWork: {
      tag: 'How we work',
      title1: 'Four steps to',
      title2: 'your experience',
      s1t: 'Choose your experience',
      s1d: 'Brunch, sunset or intimate celebration. You choose the plan that resonates best with you.',
      s2t: 'Book your date',
      s2d: 'We confirm availability and secure your day with a small deposit.',
      s3t: 'We personalize every detail',
      s3d: 'Flowers, decoration, location and custom surprises to make everything unique.',
      s4t: 'Enjoy the moment',
      s4d: "You arrive and everything is ready. All that's left is to relax and live the moment."
    },
    testimonials: {
      tag: 'What those who already lived it say',
      title1: 'Stories that',
      title2: 'are felt',
      t1e: 'Surprise birthday',
      t1q: 'We booked this picnic experience as a surprise for my birthday and it was absolutely wonderful, in a spectacular location. The attention to detail was incredible. I would recommend it without hesitation.',
      t2e: 'Romantic dinner',
      t2q: 'Our experience with this team was simply wonderful. They organize picnics and romantic dinners with exceptional attention to detail: from the elegant decoration to the quality of the food, everything is designed to create a magical atmosphere. The setup exceeded our expectations and turned the moment into something unforgettable.',
      t3e: 'Romantic experience',
      t3q: 'An incredible experience! Highly recommended, impeccable and friendly service, the food prepared with exquisite care in every detail, the ideal location and everything absolutely delicious. Thank you so much!',
      t4e: "Couple's picnic",
      t4q: 'Simply spectacular: wonderful people, great food, excellent service and impeccable communication. And most importantly, a truly unforgettable experience.',
      t5e: 'Gourmet picnic',
      t5q: 'Impeccable experience. We loved the attention to detail, the service was excellent and the food a 10/10. Thank you very much!'
    },
    middle: {
      tag: 'They have already lived the experience',
      title1: "Now it's",
      title2: 'your turn',
      btn: 'Book your moment'
    },
    faq: {
      tag: 'Frequently asked questions',
      title1: 'Everything you',
      title2: 'need to know',
      desc: 'If you have any other questions, we will be happy to assist you personally.',
      q1: 'How do I book my experience?',
      a1: 'Write to us through the contact form, Instagram or WhatsApp. We design your custom experience and confirm availability in less than 24 hours.',
      q2: 'What payment methods do you accept?',
      a2: 'We accept bank transfer, Bizum and card payment. To confirm the booking we ask for a 30% deposit and the rest on the day of the experience.',
      q3: 'How long does a picnic last?',
      a3: 'Standard experiences last 2 hours. If you need more time, we can extend it. We let you enjoy without rushing and we take care of the setup and cleanup.',
      q4: 'Where do the picnics take place?',
      a4: 'We work in three locations selected for their unique beauty: Palm Mar, with intimate coves and views of the Atlantic; Abama, among tropical vegetation facing the ocean; and Los Gigantes, with its imposing cliffs at sunset. If you prefer, we can suggest the ideal spot according to your experience.',
      q5: 'Can I change the date?',
      a5: 'Yes. You can change the date up to 48h before at no cost. In case of bad weather, we reschedule without any problem so you can live the experience with sun.',
      q6: 'Can the experience be customized?',
      a6: 'Of course. Themed decoration, specific flowers, messages, proposals, photographer, live musician... If you imagine it, we create it.'
    },
    finalCta: {
      tag: 'Your moment awaits',
      title1: 'Are you ready to live',
      title2: 'the experience?',
      desc: 'We create memorable moments in magical places in Tenerife.',
      btn: 'Book now'
    },
    contact: {
      tag: 'Book your experience',
      title1: "Let's start",
      title2: 'designing your moment',
      desc: "Fill out the form and we'll take you directly to WhatsApp with your message ready. We reply in less than 24h.",
      b1: 'Reply in less than 24 hours',
      b2: 'Fully customized proposal',
      b3: 'No obligation',
      btnDirect: 'Write to us directly',
      name: 'Name',
      namePh: "What's your name?",
      phone: 'Phone',
      phonePh: 'Your phone',
      email: 'Email',
      emailPh: 'Email address',
      exp: 'Experience',
      msg: 'Tell us your idea',
      msgPh: 'Tell us what experience you want to create',
      btn: 'Send via WhatsApp',
      opt1: 'Sunset',
      opt2: 'Ocean',
      opt3: 'Celebration'
    },
    footer: {
      nav: 'Navigation',
      contact: 'Contact',
      wa: 'Direct WhatsApp',
      desc: 'We design unique romantic experiences in the most magical corners of Tenerife. Every detail tells a story.',
      copy: '© 2026 Yes Picnic Tenerife · All rights reserved'
    },
    floating: {
      btn: 'Book via WhatsApp'
    }
  }
};
type LanguageContextType = {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (key: string) => string;
};
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLangState] = useState<Language>('es');
  useEffect(() => {
    const stored = localStorage.getItem('yp-lang') as Language;
    if (stored === 'es' || stored === 'en') {
      setLangState(stored);
    }
  }, []);
  const setLang = (newLang: Language) => {
    setLangState(newLang);
    localStorage.setItem('yp-lang', newLang);
  };
  const t = (key: string): string => {
    const keys = key.split('.');
    let current: any = translations[lang];
    for (const k of keys) {
      if (current[k] === undefined) {
        return key;
      }
      current = current[k];
    }
    return current as string;
  };
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-300">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}